module.exports = __webpack_public_path__ + "img/2.935f9570.jpg";